import { AssetDto } from '@nusign/picflow-backend-types';
import { Rect } from '../../classes/rect.class';
import { UploadObj } from '../../classes/upload-obj.class';
import { randomString } from '../../lib/random-string';

export class GalleryItem {
  asset: AssetDto;
  dimensions = new Rect();
  bounds = new Rect();
  color: string;
  swapped?: number;
  previewUpload?: UploadObj;
  id: string;

  constructor(asset: AssetDto = undefined) {
    this.asset = asset;
    this.id = asset?.id || randomString(12);
  }
}

export interface FakeAssetDto extends AssetDto {
  isFake: true;
}

export class FakeGalleryItem extends GalleryItem {
  constructor(asset: FakeAssetDto = undefined) {
    asset.isFake = true;
    super(asset);
  }
}
